export const DrawerPlacements = ['left', 'right'] as const
export type DrawerPlacement = (typeof DrawerPlacements)[number]
export const DrawerSizes = ['sm', 'md', 'lg'] as const
export type DrawerSize = (typeof DrawerSizes)[number]
